import React from 'react';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import { Icon, message } from '@/components';
import { RootStore } from '@/models';
import ActionBtn from '../ActionBtn';
import styles from './index.less';
import classNames from 'classnames';
import { FeedbackPanelPopover } from '@/components/FeedbackPanel';

interface Props extends Partial<Pick<RootStore, 'rtc' | 'user'>> {
  RTCInstance?: RootStore['rtc'];
}
const FeedbackBtn: React.FC<Props> = inject(({ store }) => {
  return {
    RTCInstance: store.rtc,
  };
})(
  observer((props) => {
    const { RTCInstance } = props;
    const { formatMessage } = useIntl();
    const [, setIsFeedbackPopoverVisible] = React.useState(false);

    const onFeedbackVisibleChange = React.useCallback(
      (change: boolean) => {
        if (RTCInstance?.breakLineReconnecting) {
          setIsFeedbackPopoverVisible(false);
          return;
        }
        setIsFeedbackPopoverVisible(change);
      },
      [RTCInstance]
    );

    return (
      <FeedbackPanelPopover
        type="meeting"
        align={{ offset: [0, 12] }}
        placement="top"
        onVisibleChange={onFeedbackVisibleChange}
      >
        <ActionBtn
          title={formatMessage({ id: 'FEEDBACK' })}
          className={classNames(styles.feedbackBtn, {
            [styles.disable]: RTCInstance?.breakLineReconnecting,
          })}
        >
          <Icon className={styles.icon} name="icon-feedback" size={24} mode="symbol" />
        </ActionBtn>
      </FeedbackPanelPopover>
    );
  })
);

export default FeedbackBtn;
